const maxWidth = (px: number) => `(max-width: ${px}px)`;
const minWidth = (px: number) => `(min-width: ${px}px)`;
const betweenWidths = (min: number, max: number) =>
  `(min-width: ${min}px) and (max-width: ${max}px)`;

export const ABYSS_BREAKPOINTS = {
  xs: 0,
  sm: 360,
  md: 744,
  lg: 1248,
} as const;

export const APP_BREAKPOINTS = {
  smallestMobile: 320,
  mobile: 480,
  compactAvailability: 600,
  smallerTablet: 820,
  tablet: 1024,
  desktop: 1025,
  wideTablet: 1200,
  consolidatedScheduling: 1100,
} as const;

export const MEDIA_QUERIES = {
  smallestMobileMax: maxWidth(APP_BREAKPOINTS.smallestMobile),
  mobileMax: maxWidth(APP_BREAKPOINTS.mobile),
  mediumMax: maxWidth(ABYSS_BREAKPOINTS.md),
  compactAvailabilityMax: maxWidth(APP_BREAKPOINTS.compactAvailability),
  smallerTabletMax: maxWidth(APP_BREAKPOINTS.smallerTablet),
  tabletMax: maxWidth(APP_BREAKPOINTS.tablet),
  tabletMin: minWidth(APP_BREAKPOINTS.mobile + 1),
  tabletRange: betweenWidths(APP_BREAKPOINTS.mobile + 1, APP_BREAKPOINTS.tablet),
  desktopMin: minWidth(APP_BREAKPOINTS.desktop),
  wideTabletMax: maxWidth(APP_BREAKPOINTS.wideTablet),
  consolidatedSchedulingMax: maxWidth(APP_BREAKPOINTS.consolidatedScheduling),
} as const;
